import { useMutation } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { UpdateCartQuantitiesRequest } from 'src/types/cart/updateQuantities';
import axiosInstance from 'src/utils/axios';

async function updateCartQuantities(request: UpdateCartQuantitiesRequest): Promise<void> {
  await axiosInstance.put(api.updateCartQuantities, request);
}

interface UseUpdateCartQuantitiesMutationOptions {
  onSuccess?: (data: void, request: UpdateCartQuantitiesRequest) => void;
  onError?: (error: unknown) => void;
}

const useUpdateCartQuantitiesMutation = ({
  onSuccess,
  onError,
}: UseUpdateCartQuantitiesMutationOptions = {}) =>
  useMutation({
    mutationFn: updateCartQuantities,
    onSuccess: (data, request) => {
      onSuccess?.(data, request);
    },
    onError: (error) => {
      onError?.(error);
    },
  });

export default useUpdateCartQuantitiesMutation;
